export enum LengthUnits {
  meter = 'meter',
  mile = 'mile',
  feet = 'feet',
}
